import axios from "axios";
import store from "../store";
import { logoutThunk } from "../store/slices/authSlice";

const axiosInstance = axios.create();

axiosInstance.interceptors.request.use((config) => {
  const jwt = store.getState().auth.jwt;
  if (jwt) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${jwt}`;
  }
  return config;
});

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      store.dispatch(logoutThunk());
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
